export { default as WhatsNewFluentPane } from './components/WhatsNewFluentPane';
export { initializeWhatsNew } from './orchestrators/initializeWhatsNew';

import './orchestrators/openWhatsNewPaneOrchestrator';
